/* eslint-disable no-unsafe-optional-chaining */
import { Select } from "antd";
import PropTypes from "prop-types";

export const CommonSelect = ({
  value,
  placeholder,
  onChange,
  options,
  label,
  isEnablePlaceholder = true,
  isLoading = false,
  required = false,
  disabled = false,
}) => {
  return (
    <>
      {label && (
        <label className="form-label">
          {label} {required && <sub style={{ color: "red" }}>*</sub>}
        </label>
      )}
      <Select
        disabled={disabled}
        loading={isLoading}
        size="large"
        value={value || ""}
        className="w-100"
        onChange={onChange}
        showSearch
        filterOption={(input, option) =>
          (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
        }
      >
        <Select.Option value="" disabled={isEnablePlaceholder}>
          {placeholder}
        </Select.Option>
        {options?.length &&
          options.map((item, idx) => (
            <Select.Option value={item._id} key={idx}>
              {`${item.name} ${item?.id ? `(${item.id})` : ""}`}
            </Select.Option>
          ))}
      </Select>
    </>
  );
};

CommonSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  isEnablePlaceholder: PropTypes.bool,
  isLoading: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};
